import type { Case } from "@artemis-group/aiw-contracts";
import type { CaseUiState } from "../components/case-card";

/** Display the recorded outcome, never infer success from an attempted verdict. */
export function caseState(k: Case): CaseUiState {
  if (k.replacement_case_id) return "superseded";
  if (k.decision === "request_revision") return "revision requested";
  if (k.action_status === "rejected" || k.decision === "reject") return "declined";
  if(k.delivery_status){
    if(k.delivery_status==="uncertain")return "needs checking";
    if(k.delivery_status==="queued")return "approved";
    if(k.delivery_status==="confirmed")return "succeeded";
    if(k.delivery_status==="failed")return "failed";
    if(k.delivery_status==="cancelled")return "declined";
    return "executing";
  }
  if (k.action_status === "executed") return k.command === "send_communication" ? "approved" : "succeeded";
  if (k.action_status === "failed" || k.action_status === "denied") return "failed";
  if (k.action_status === "expired") return "expired";
  if (k.status === "expired" || (k.status === "pending" && k.expires_at && Date.parse(k.expires_at) <= Date.now())) return "expired";
  if (k.status === "decided") return k.decision === "approve" || k.decision === "edit" ? "approved" : "failed";
  return k.revision_of ? "revised" : "proposed";
}
